class ProfessionsList
{
  #professionsListElements = null;

  constructor()
  {
    this.#professionsListElements = document.querySelectorAll('[data-professions-list]');
  }

  init()
  {
    if(this.#professionsListElements.length)
    {
      this.#professionsListElements.forEach((list) =>
      {
        this.#addObserver(list);
      });
    }
  }

  #addObserver = (element) =>
  {
    const observer = new IntersectionObserver((entries, observerElement) =>
    {
      entries.forEach((entry) =>
      {
        if(entry.isIntersecting)
        {
          if(entry.target.querySelector('[data-professions-list-bar]'))
          {
            const progressBar = entry.target.querySelector('[data-professions-list-bar]');
            progressBar.style.width = `${progressBar.dataset.professionsListValue}%`;
            observerElement.unobserve(entry.target);
          }
        }
      });
    }, {
      root: element,
      threshold: 1,
    });

    element.querySelectorAll('[data-profession-card]').forEach((card) =>
    {
      observer.observe(card);
    });
  };
}

const initProfessionsList = () =>
{
  const professionsList = new ProfessionsList();
  professionsList.init();
};

export { initProfessionsList };
